// src/components/VerifiedBadge.js
import React from 'react';
import './VerifiedBadge.css';

const VerifiedBadge = ({ licenceNo, size = 'sm' }) => (
  <span className={`verified-badge verified-${size}`} title={licenceNo ? `Waste carrier registration: ${licenceNo}` : 'Waste carrier registration'}>
    ✅ Registered {licenceNo && <span className="licence-no">· {licenceNo}</span>}
  </span>
);

export default VerifiedBadge;
